var freeShipping = "https://shopfront-cdn.tekoapis.com/static/64c212730613c00d.svg";

export { freeShipping as default };
